import React, { useState } from "react";
import { Copy, ExternalLink, X, Check } from "lucide-react";
import Button from "./Button";

const ShareLinkModal = ({ isOpen, onClose, link, title = "Share Link" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  const handleOpenInNewTab = () => {
    window.open(link, "_blank");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-6 w-full max-w-md mx-4 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Link Display */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Shareable Link
          </label>
          <div className="bg-white/5 border border-white/10 rounded-lg p-3 font-mono text-sm text-gray-300 break-all">
            {link}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <Button
            onClick={handleCopy}
            className={`flex-1 flex items-center justify-center space-x-2 transition-all duration-200 ${
              copied
                ? "bg-green-500 hover:bg-green-600 text-white"
                : "bg-[#B8460E] hover:bg-[#8B3A0E] text-white"
            }`}
          >
            {copied ? (
              <>
                <Check className="h-4 w-4" />
                <span>Copied!</span>
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" />
                <span>Copy Link</span>
              </>
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={handleOpenInNewTab}
            className="flex-1 flex items-center justify-center space-x-2 bg-white/10 hover:bg-white/20 text-white border-white/20"
          >
            <ExternalLink className="h-4 w-4" />
            <span>Open</span>
          </Button>
        </div>

        {/* Cancel Button */}
        <div className="mt-3">
          <Button
            variant="secondary"
            onClick={onClose}
            className="w-full bg-white/5 hover:bg-white/10 text-gray-300 border-white/10"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShareLinkModal;
